export const redirectUrls = (redirectValue, namesArray, redirectValues) => {
    const hrefSplit = window.location.href.split(redirectValue)[1] || '';
    if(hrefSplit) {
        const checkHrefWithNameArray = namesArray.map((a) => a.toLowerCase() === hrefSplit.split('').join('').toLowerCase() ? true : false)
        if (checkHrefWithNameArray) {
        const redirectLink = redirectValues.filter((a) => a.name.toLowerCase() === hrefSplit && a.value).map(a => (a.value))[0];
        window.location.replace(decodeURIComponent(redirectLink.toString()))
        }
    }
}